<template>
  <!-- Bind theme class here -->
  <div :class="['erc-vehicle-catalog-container', currentTheme]" id="erc-vehicle-catalog-container">
    <div class="form">
      <vehicle-catalog-form @getRemaps="getRemaps"/>
    </div>
    <remap-info :vehicle-data="vehicleData" @remapDataFetched="scrollToData" />
  </div>
</template>

<script>
import VehicleCatalogForm from "@/components/Form";
import RemapInfo from "@/components/RemapInfo";

export default {
  name: 'VehicleCatalog',
  components: {
    'vehicle-catalog-form': VehicleCatalogForm,
    'remap-info': RemapInfo,
  },
  data() {
    return {
      vehicleData: {},
      currentTheme: 'theme-light' // Default theme class
    }
  },
  mounted() {
    // Apply settings when component is mounted
    if (window.ercData && window.ercData.settings) {
      const settings = window.ercData.settings;

      // 1. Set Theme Class
      this.currentTheme = `theme-${settings.theme || 'light'}`;

      // 2. Set CSS Color Variables on the root element of this component
      const rootEl = this.$el;
      if (rootEl) {
        rootEl.style.setProperty('--erc-color-oem-val', settings.color_oem);
        rootEl.style.setProperty('--erc-color-st1-val', settings.color_st1);
        rootEl.style.setProperty('--erc-color-st2-val', settings.color_st2);
      }
    } else {
        console.warn("ERC Catalogue: Settings data not found (ercData.settings). Using defaults.");
        // Optionally set default CSS variables here if needed, though CSS fallback should work
    }
  },
  methods: {
    getRemaps(formData) {
      this.vehicleData = {...formData}
    },
    scrollToData() {
      this.$nextTick(() => {
        const remapInfoElement = document.querySelector('#erc-vehicle-remap-info');
        if (remapInfoElement) {
            const remapInfoRect = remapInfoElement.getBoundingClientRect();
            const scrollTo = window.scrollY + remapInfoRect.top;
            window.scroll({ top: scrollTo, behavior: 'smooth' }); // Removed duration, not standard
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.erc-vehicle-catalog-container {
  box-sizing: border-box;
  max-width: 1140px;
  margin: 0 auto;

  // --- Define CSS Variables with Fallbacks ---
  --erc-color-oem-val: #00aeff; // Default OEM color
  --erc-color-st1-val: #ff5419; // Default ST1 color
  --erc-color-st2-val: #e82409; // Default ST2 color

  // Theme-independent variables using the settings
  --erc-color-oem: var(--erc-color-oem-val);
  --erc-color-st1: var(--erc-color-st1-val);
  --erc-color-st2: var(--erc-color-st2-val);

  // --- Light Theme (Default) Variables ---
  --erc-text-color: #333; // General text
  --erc-text-light: #54595f; // Lighter text
  --erc-text-heading: #000; // Headings
  --erc-bg-color: #fff; // Background for sections like remap info
  --erc-form-bg-color: var(--erc-color-oem); // Form background
  --erc-form-text-color: #fff; // Form label text
  --erc-select-bg-color: #fff; // Select background
  --erc-select-text-color: #000; // Select text
  --erc-select-border-color: #818a91; // Select border
  --erc-button-bg-color: #fff; // Button background
  --erc-button-text-color: var(--erc-color-oem); // Button text
  --erc-button-hover-bg-color: #00699b; // Button hover bg
  --erc-button-hover-text-color: #fff; // Button hover text
  --erc-border-color: #eee; // General borders
  --erc-donut-track-color: #ffffff; // White track for light theme
  --erc-donut-foreground-color: #f0f0f0; // Light grey foreground

  * {
    box-sizing: border-box;
  }

  .form {
    padding: 30px;
    background-color: var(--erc-form-bg-color); // Use variable
    border-radius: 18px 18px 0 0;
    color: var(--erc-form-text-color); // Set base text color for form area
  }

  // Apply general background and text color
  background-color: var(--erc-bg-color);
  color: var(--erc-text-color);
}

// --- Dark Theme Overrides ---
.erc-vehicle-catalog-container.theme-dark {
  --erc-text-color: #ccc;
  --erc-text-light: #aaa;
  --erc-text-heading: #fff;
  --erc-bg-color: #000; // Dark background
  --erc-form-bg-color: var(--erc-color-oem);
  --erc-form-text-color: #ccc;
  --erc-select-bg-color: #444;
  --erc-select-text-color: #eee;
  --erc-select-border-color: #666;
  --erc-button-bg-color: #555;
  --erc-button-text-color: #eee;
  --erc-button-hover-bg-color: #777;
  --erc-button-hover-text-color: #fff;
  --erc-border-color: #444;
  --erc-donut-track-color: #444; // Darker track for dark theme
  --erc-donut-foreground-color: #555; // Slightly lighter foreground

  // Example: Adjust specific element colors if needed
  // .brand-name { color: var(--erc-text-heading); }
}

</style>
